export const normalizeRenderTaskIds = (taskIds) => {
  if (typeof taskIds !== 'string') return taskIds
  return taskIds.replace(/^.*[A-Za-z]/, '')
}
